import { DescriptionField } from "@dash/description-list";
import { SectionHeader } from "@dash/page";
import Decimal from "decimal.js";

type Props = {
  priceList: string | null;
  defaultDiscount: Decimal | null;
  pricingNotes: string;
};

export const PayerPricingRules: React.FC<Props> = ({ priceList, defaultDiscount, pricingNotes }) => (
  <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem", width: "100%" }}>
    <SectionHeader isHr css={{ margin: 0 }}>
      Warunki handlowe
    </SectionHeader>
    <div css={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem" }}>
      <DescriptionField label="Cennik">{priceList ?? "Brak"}</DescriptionField>
      <DescriptionField label="Rabat podstawowy">
        {defaultDiscount === null ? "-" : `${defaultDiscount.mul(100).toFixed(0)}%`}
      </DescriptionField>
    </div>
    {pricingNotes && <DescriptionField label="Komentarz">{pricingNotes}</DescriptionField>}
  </div>
);
